<template>
  <section class="banner_1">
    <m-img src="@/mobile_plan/assets/image/1.jpg"></m-img>
  </section>
</template>

<script>
export default {}
</script>